import React from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormSelect } from "../../../../components";
import {
  ACTIVITY_TYPE_OPTIONS,
  EVENT_TYPE_OPTIONS_MARKETING,
  FORM_CONSTANTS,
} from "../SelectRules.constants";
import ActivitySelector from "../ActivitySelector";
import { ActivityOption } from "./../../TriggerForm.types";

interface MarketingActivityFieldsProps {
  formValues: any;
  activities: ActivityOption[];
  handleActivitySearch: (searchText: string) => void;
  loadMoreActivities: () => void;
  isLoadingMore: boolean;
  hasMoreResults: boolean;
  isLoading: boolean;
  isTinyEmail: boolean;
}

const MarketingActivityFields: React.FC<MarketingActivityFieldsProps> = ({
  formValues,
  activities,
  handleActivitySearch,
  loadMoreActivities,
  isLoadingMore,
  hasMoreResults,
  isLoading,
  isTinyEmail,
}) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name="activityId"
          control={control}
          render={({ field: { onChange, value } }) => (
            <ActivitySelector
              value={value || ""}
              onChange={onChange}
              options={activities}
              onInputChange={handleActivitySearch}
              isLoading={isLoadingMore || isLoading}
              hasMore={hasMoreResults}
              onScrollEnd={loadMoreActivities}
              placeholder={"Search Campaign"}
              label={"Campaign"}
              enableInfiniteScroll={isTinyEmail}
            />
          )}
        />
      </Grid>

      {formValues.activityId && (
        <Grid item xs={12}>
          <Controller
            name="event"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FormSelect
                field={field}
                label="Event"
                placeholder="Select event"
                options={EVENT_TYPE_OPTIONS_MARKETING}
              />
            )}
          />
        </Grid>
      )}

      {formValues.event && (
        <Grid item xs={12}>
          <FormControl fullWidth disabled>
            <InputLabel id="from-label">From</InputLabel>
            <Select
              labelId="from-label"
              id="from-select"
              value={FORM_CONSTANTS.FROM_VALUES.ANYTIME}
              label="From"
              size="small"
            >
              <MenuItem value={FORM_CONSTANTS.FROM_VALUES.ANYTIME}>
                Any time
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
    </>
  );
};

export default MarketingActivityFields;
